import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { AdminAuthProvider, useAdminAuth } from "@/lib/adminAuth";
import { LayoutDashboard, Users, Sparkles, Cpu, Package, Crown, ShieldCheck, Receipt, Image, Settings, LogOut, Star, Bell, Languages, UserCheck, FileText, Wallet, MessageSquare, Key } from "lucide-react";
import { useEffect } from "react";

const NAV = [
  { to: "/admin/dashboard", label: "Genel", icon: LayoutDashboard, test: "nav-dashboard" },
  { to: "/admin/users", label: "Kullanıcılar", icon: Users, test: "nav-users" },
  { to: "/admin/password-resets", label: "Şifre Sıfırlama", icon: Key, test: "nav-password-resets" },
  { to: "/admin/fortune-types", label: "Fal Türleri", icon: Sparkles, test: "nav-fortune-types" },
  { to: "/admin/fortune-requests", label: "Fal İstekleri", icon: Star, test: "nav-fortune-requests" },
  { to: "/admin/ai", label: "AI Sağlayıcıları", icon: Cpu, test: "nav-ai" },
  { to: "/admin/packages", label: "Jeton Paketleri", icon: Package, test: "nav-packages" },
  { to: "/admin/plans", label: "Premium Planlar", icon: Crown, test: "nav-plans" },
  { to: "/admin/push", label: "Push Bildirim", icon: Bell, test: "nav-push" },
  { to: "/admin/i18n", label: "Diller & Çeviriler", icon: Languages, test: "nav-i18n" },
  { to: "/admin/falcilar", label: "Falcı Marketplace", icon: UserCheck, test: "nav-falcilar" },
  { to: "/admin/falci-applications", label: "Falcı Başvuruları", icon: FileText, test: "nav-falci-apps" },
  { to: "/admin/consultations", label: "Konsültasyonlar", icon: MessageSquare, test: "nav-consultations" },
  { to: "/admin/withdrawals", label: "Çekim Talepleri", icon: Wallet, test: "nav-withdrawals" },
  { to: "/admin/whitelist", label: "Yönetici Listesi", icon: ShieldCheck, test: "nav-whitelist" },
  { to: "/admin/transactions", label: "İşlemler", icon: Receipt, test: "nav-transactions" },
  { to: "/admin/banners", label: "Reklam Banner'ları", icon: Image, test: "nav-banners" },
  { to: "/admin/settings", label: "Ayarlar", icon: Settings, test: "nav-settings" },
];

function LayoutInner() {
  const { admin, loading, logout } = useAdminAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && !admin) nav("/admin");
  }, [admin, loading, nav]);

  if (loading) return <div className="admin-bg min-h-screen flex items-center justify-center text-white/60">Yükleniyor...</div>;
  if (!admin) return null;

  return (
    <div className="admin-bg min-h-screen flex">
      <aside className="w-64 border-r border-[#27272A] p-4 flex flex-col shrink-0">
        <div className="flex items-center gap-2 px-2 py-3 mb-2">
          <Sparkles className="w-5 h-5 text-[#F59E0B]" />
          <span className="font-admin-head text-lg">FalZilla Admin</span>
        </div>
        <nav className="space-y-1 flex-1">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={n.test}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-md text-sm font-admin-body transition-colors ${isActive ? "bg-[#F59E0B]/10 text-[#F59E0B]" : "text-white/70 hover:bg-white/5 hover:text-white"}`
                }
              >
                <Icon className="w-4 h-4" />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="border-t border-[#27272A] pt-3">
          <div className="px-2 pb-2">
            <div className="text-xs text-white/40 font-admin-body">Giriş:</div>
            <div className="text-sm font-admin-body truncate">{admin.email}</div>
            <div className="text-xs text-[#F59E0B] font-admin-body">{admin.role}</div>
          </div>
          <button onClick={async () => { await logout(); nav("/admin"); }} data-testid="admin-logout-btn" className="admin-btn-ghost w-full py-2 text-sm flex items-center gap-2 justify-center">
            <LogOut className="w-4 h-4" /> Çıkış
          </button>
        </div>
      </aside>

      <main className="flex-1 p-6 md:p-8 overflow-x-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default function AdminLayout() {
  return (
    <AdminAuthProvider>
      <LayoutInner />
    </AdminAuthProvider>
  );
}
